"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var _Group = require("../../Group");

var _Hint = _interopRequireDefault(require("../../Hint"));

var Styled = _interopRequireWildcard(require("./Radio.style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var RadioInput = function RadioInput(_a) {
  var defaultChecked = _a.defaultChecked,
      field = _a.field,
      id = _a.id,
      label = _a.label,
      name = _a.name,
      value = _a.value,
      hint = _a.hint,
      props = (0, _tslib.__rest)(_a, ["defaultChecked", "field", "id", "label", "name", "value", "hint"]);
  var isInGroup = (0, _react.useContext)(_Group.GroupContext).inGroup;
  var inputName = isInGroup ? (0, _react.useContext)(_Group.GroupContext).name : field && field.name || name;
  return _react.default.createElement(Styled.RadioContainer, null, _react.default.createElement(Styled.Input, (0, _tslib.__assign)({
    "data-testid": "checkbox__" + id,
    type: "radio",
    defaultChecked: defaultChecked,
    id: id
  }, field, {
    name: inputName,
    value: field && field.value || value || id
  }, props)), _react.default.createElement(Styled.RadioButton, null, _react.default.createElement(Styled.RadioFill, null)), _react.default.createElement(Styled.RadioLabel, {
    htmlFor: id
  }, _react.default.createElement("span", null, label), hint && _react.default.createElement(_Hint.default, null, hint)));
};

RadioInput.displayName = 'RadioInput';
RadioInput.defaultProps = {
  defaultChecked: false
};
var _default = RadioInput;
exports.default = _default;